import $ from 'jquery'
import slick from 'slick-carousel'

//REVIEW CODE: it is giving error in the editor when more than one slider is added to the same page.

$(document).ready( initGallerySlider )
if (window.acf) {
  //window.acf.addAction('render_block_preview/type=gallery-slider', initGallerySlider)
}

function initGallerySlider(){
  if ($('.js-gallery-slider').length) {
    console.log('initGallerySlider')
    if ($(window).width() < 896) {
        $('.desktop-slide').remove();
    }
    if ($(window).width() > 896) {
        $('.mobile-slide').remove();
    }
    $('.js-gallery-slider').slick({
      arrows: true,
      dots: true,
      prevArrow: '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" transform="rotate(180 12 12)" fill="#1A7D84"/><path fill-rule="evenodd" clip-rule="evenodd" d="M6.77442 11.0302L11.1311 6.67357C11.4493 6.3553 11.4498 5.84041 11.1325 5.52309C10.813 5.20362 10.3001 5.20648 9.98206 5.52455L4.23981 11.2668L4.23911 11.2676L4.23835 11.2683C4.07884 11.4278 3.99968 11.6355 4 11.8431C4.00076 12.0512 4.07998 12.2588 4.23835 12.4173L4.23911 12.418L9.98201 18.1609C10.3003 18.4791 10.8151 18.4796 11.1324 18.1623C11.452 17.8428 11.4491 17.3299 11.131 17.0118L6.77437 12.6552L19.1864 12.6552C19.6336 12.6552 20 12.2914 20 11.8427C20 11.3908 19.6357 11.0302 19.1864 11.0302L6.77442 11.0302Z" fill="white"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#1A7D84"/><path fill-rule="evenodd" clip-rule="evenodd" d="M17.2256 12.9698L12.8689 17.3264C12.5507 17.6447 12.5502 18.1596 12.8675 18.4769C13.187 18.7964 13.6999 18.7935 14.0179 18.4755L19.7602 12.7332L19.7609 12.7324L19.7617 12.7317C19.9212 12.5722 20.0003 12.3645 20 12.1569C19.9992 11.9488 19.92 11.7412 19.7617 11.5827L19.7609 11.582L14.018 5.83913C13.6997 5.52087 13.1849 5.52043 12.8676 5.83774C12.548 6.1572 12.5509 6.67009 12.869 6.98815L17.2256 11.3448H4.81361C4.36638 11.3448 4 11.7086 4 12.1573C4 12.6092 4.36428 12.9698 4.81361 12.9698L17.2256 12.9698Z" fill="white"/></svg></button>',
    });
    
  }
}
